module.exports = __webpack_public_path__ + "img/warn.6746fd9c.png";